// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@conklin/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { hideElementOnPrint, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {};
primaryImageStyles.wrapper = {
    css: css`
        flex: 1;
    `,
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 300px;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            ${xScreen("gte", "lg")} {
                justify-content: flex-start;
            }
            ${xScreen("lte", "md")} {
                border-radius: 1px;
            }
            img {
                height: auto;
                max-width: 100%;
                width: 100%;
                @media print {
                    max-height: 400px;
                }
            }
        `,
    },
    image: {
        css: css`
            margin: auto;
            cursor: pointer;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
        `,
    },
    container: {
        css: css`
            position: relative;
            flex-grow: 1;
            max-width: 658px;
            max-height: 658px;
        `,
    },
} as any;

primaryImageStyles.fullPrimaryImage = {
    centeringWrapper: {
        css: css`
            min-width: 300px;
        `,
    },
    image: {
        css: css`
            cursor: auto;
            img {
                width: auto;
                max-height: 85vh;
            }
        `,
    },
    img: {
        css: css`
            cursor: auto;
            width: auto;
            max-height: 85vh;
        `,
    },
};

primaryImageStyles.primaryImageWrapper = {
    css: css`
        position: relative;
        @media print {
            display: flex;
            justify-content: center;
        }
    `,
};
primaryImageStyles.modalImageContainer = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

primaryImageStyles.badgeTextWrapper = {
    css: css`
        &&&& {
            top: 10px;
            left: 10px;
            bottom: unset;
            max-width: max-content;
            ${hideElementOnPrint}
        }
    `,
};

primaryImageStyles.videoStyles = {
    container: {
        css: css`
            aspect-ratio: 1/1;
            margin: 0 auto;
            padding-bottom: 0;
            max-height: 500px;
            .yt-lite {
                height: 100%;
            }
        `,
    },
    thumb: {
        css: css`
            aspect-ratio: 1 /1;
            width: 100%;
            max-height: 500px;
            img {
                aspect-ratio: 1 / 1;
                width: 100%;
                max-width: 100%;
            }
        `,
    },
};

primaryImageStyles.enlargeBtn = {
    css: css`
        position: absolute;
        right: 8px;
        bottom: 8px;
        z-index: 1;
        padding: 0;
        height: 16px;
        width: 16px;
    `,
};
